<template>
    <div class="stretch">
        <ErrorField class="column"
                    v-if="!comparatorHidden"
                    type="required"
                    field="Operator"
                    :condition="errors.comparator">
            <Dropdown
                class="operator-field"
                :uniqueId="`segmentConditionOperator${id}${comparator ? comparator : ''}`"
                :selectedId="comparator"
                :options="comparatorOptions"
                defaultText="Select Operator"
                :searchEnabled="false"
                @dropdownSelectedItemChanged="$emit('update:comparator', $event.id)"
                height="34"
            />
        </ErrorField>
        <div class="stretch">
            <ErrorField class="column"
                        :overflow="overflow"
                        :class="fieldClass" :errors="valueErrors">
                <slot></slot>
            </ErrorField>
            <slot name="afterInput"></slot>
        </div>
    </div>
</template>

<script>
import Dropdown from 'components/dropdowns/Dropdown.vue';
import ErrorField from 'components/errorField/ErrorField.vue';
import errorFieldTypes from 'components/errorField/errorFieldTypes';

export default {
    name: 'BaseField',
    components: { ErrorField, Dropdown },
    props: {
        comparator: String,
        fieldClass: String,
        overflow: Boolean,
        id: Number,
        comparatorOptions: {
            type: Array,
            default: () => ([])
        },
        comparatorHidden: {
            type: Boolean,
            default: false
        },
        errors: {
            type: [Object, Boolean],
            default: () => ({})
        }
    },
    computed: {
        valueErrors() {
            return [
                {
                    type: errorFieldTypes.required,
                    field: 'This',
                    condition: this.errors.value
                },
                {
                    type: errorFieldTypes.versionFormat,
                    condition: this.errors.valueVersionFormat
                },
                {
                    type: errorFieldTypes.dateFormat,
                    condition: this.errors.valueDateFormat
                },
                {
                    type: errorFieldTypes.numberBetween,
                    field: 'Age',
                    value: '1-99',
                    condition: this.errors.age
                },
                {
                    type: errorFieldTypes.numberBetween,
                    field: 'This',
                    value: '1-999999',
                    condition: this.errors.totalInAppPurchases || this.errors.apiLevel || this.errors.levelId
                }
            ];
        }
    }
};
</script>
